

























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Mixins, Vue } from 'vue-property-decorator';
import { SlotsMixin } from '@fruitpackage/mixins';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    mixins: [
        SlotsMixin, 
    ],
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class PageMain extends Vue {};

